// extracted by mini-css-extract-plugin
export default {"bar":"TableChart_bar__uif7E"};